export const PAGE_LIMIT = 100;
export const SHOW_PARAMS = [ 'rq', 'rs', 'i', 'w', 'cl', 'ctr', 'vC', 'cv', 'cD', 'cs', 'oR', 'r', 'rT', 'roi', 'roi2' ];
export const CSV_PARAMS = [ [ 'a', 'Affid' ], [ 's', 'Subid' ], [ 'cc', 'Country' ], [ 'rq', 'Requests' ], [ 'rs', 'Response'], [ 'i', 'Impressions' ], [ 'w', 'Won %' ], [ 'cl', 'Clicks' ], [ 'ctr', 'CTR' ], [ 'vC', 'Voluum Clicks' ], [ 'cv', 'Conversions' ], [ 'cD', 'Clicks Disc %' ], [ 'cs', 'Cost' ], [ 'oR', 'ONW Revenue' ], [ 'r', 'Revenue' ], [ 'rT', 'Total Revenue' ], [ 'roi', 'ROI %' ], [ 'roi2', 'ROI' ] ];


// WEBPACK FOOTER //
// ./src/scenes/PushapiExtended/config.js